module.exports = __webpack_public_path__ + "03_mid_black.bbb6f827.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_mid_black.png
// module id = nKNt
// module chunks = 0